import { isValidPhoneNumber, parsePhoneNumber } from "react-phone-number-input";
import * as Yup from "yup";
import checkout from "./form";

const {
  formField: { number, description, location, timezone, project, status },
} = checkout;
export default Yup.object().shape({
  [number.name]: Yup.string()
    .required(number.errorMsg)
    .test("phone-validate", "Phone number is not valid", (value) => {
      if (typeof value === "string" && parsePhoneNumber(value)) {
        return isValidPhoneNumber(parsePhoneNumber(value).number);
      }
      return false;
    }),
  [description.name]: Yup.string().required(description.errorMsg),
  [location.name]: Yup.string().required(location.errorMsg),
  [timezone.name]: Yup.string().required(timezone.errorMsg),
  [project.name]: Yup.string(), // .required(project.errorMsg),
  [status.name]: Yup.bool(),
});
